import { render, staticRenderFns } from "./ReasoningSteps.vue?vue&type=template&id=273db192&scoped=true"
import script from "./ReasoningSteps.vue?vue&type=script&lang=js"
export * from "./ReasoningSteps.vue?vue&type=script&lang=js"
import style0 from "./ReasoningSteps.vue?vue&type=style&index=0&id=273db192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273db192",
  null
  
)

export default component.exports